











import NavBar from '@/modules/nav/components/NavBar.vue';
import AsideMenu from '@/modules/core/components/AsideMenu.vue';
import { Component, Vue } from 'vue-property-decorator';
import { isRouteAuthorized } from '@/router';
import AuthenticationService from './auth.service';
import { PermissionType, RoleType } from '@shared/common/types';
import { User } from '@/modules/user/user';

interface MenuLink {
  to: string;
  icon?: string;
  label: string;
  visible?: boolean;
  visibilityByRouteName?: boolean;
  routeName?: string;
}

@Component({
  components: {
    AsideMenu,
    NavBar,
  },
})
export default class App extends Vue {
  public AuthenticationService = AuthenticationService;
  public get menu(): any {
    return [
      // 'General',
      [
        {
          to: '/home',
          icon: 'desktop-mac',
          label: 'Tableau de bord',
          visibilityByRouteName: true,
          routeName: 'home',
        },
        {
          to: '/alerts',
          icon: 'alert',
          label: 'Alertes',
          visibilityByRouteName: true,
          routeName: 'alerts',
        },
        {
          to: '/breadcrumbs',
          icon: 'lifebuoy',
          label: 'Ligne de vie',
          visibilityByRouteName: true,
          routeName: 'breadcrumbList',
        },
        {
          to: '/technical-messages',
          icon: 'message-cog',
          label: 'Messages techniques',
          visibilityByRouteName: true,
          routeName: 'technicalMessages',
        },
        {
          to: '/devices',
          icon: 'cellphone',
          label: 'Terminaux',
          visibilityByRouteName: true,
          routeName: 'devices',
        },
        {
          to: '/users?role=SUBSCRIBER',
          icon: 'account',
          label: 'Abonnés',
          get visible(): boolean {
            const user = AuthenticationService.user as User;
            return user.can(PermissionType.viewUser) && user.canViewRoles(RoleType.SUBSCRIBER) && !user.isAdmin();
          },
        },
        {
          to: '/subscriptions',
          icon: 'grid',
          label: 'Programmations',
          visibilityByRouteName: true,
          routeName: 'subscriptionList',
        },
        {
          to: '/users?role=MANAGER',
          icon: 'account-tie',
          label: 'Gestionnaires',
          get visible(): boolean {
            const user = AuthenticationService.user as User;
            return user.can(PermissionType.viewUser) && user.canViewRoles(RoleType.MANAGER) && !user.isAdmin();
          },
        },
        {
          to: '/users',
          icon: 'account',
          label: 'Utilisateurs',
          get visible(): boolean {
            const user = AuthenticationService.user as User;
            return user.isAdmin() || user.getSelectableRoles().length > 0;
          },
        },
        {
          to: '/agencies',
          icon: 'office-building',
          label: 'Agences',
          visibilityByRouteName: true,
          routeName: 'agencyList',
        },
        {
          to: '/tags',
          icon: 'tag-multiple',
          label: 'Tags',
          visibilityByRouteName: true,
          routeName: 'tagList',
        },
                {
          to: '/pv-logs',
          icon: 'file-search',
          label: 'Logs PV',
          visibilityByRouteName: true,
          routeName: 'pvLogList',
        },
      ],
      // 'Examples',
      // [
      //   {
      //     to: '/tables',
      //     label: 'Tables',
      //     icon: 'table',
      //     updateMark: true,
      //   },
      //   {
      //     to: '/forms',
      //     label: 'Forms',
      //     icon: 'square-edit-outline',
      //   },
      //   {
      //     to: '/profile',
      //     label: 'Profile',
      //     icon: 'account-circle',
      //   },
      //   {
      //     label: 'Submenus',
      //     subLabel: 'Submenus Example',
      //     icon: 'view-list',
      //     menu: [
      //       {
      //         href: '#void',
      //         label: 'Sub-item One',
      //       },
      //       {
      //         href: '#void',
      //         label: 'Sub-item Two',
      //       },
      //     ],
      //   },
      // ],
      // 'About',
      // [
      //   {
      //     href: 'https://admin-one-vue-cli.justboil.me',
      //     label: 'Premium Demo',
      //     icon: 'credit-card',
      //   },
      //   {
      //     href: 'https://justboil.me/bulma-admin-template/one',
      //     label: 'About',
      //     icon: 'help-circle',
      //   },
      // ],
    ];
  }

  public get authorizedMenuEntries(): any[] {
    return [
      this.menu[0].filter((menuEntry: any) =>
        this.isMenuLinkVisible(menuEntry),
      ),
    ];
  }

  public isMenuLinkVisible(menuLink: MenuLink): boolean | undefined {
    if (menuLink.hasOwnProperty('visible')) {
      return menuLink.visible;
    }

    if (menuLink.visibilityByRouteName) {
      return isRouteAuthorized(menuLink.routeName as string);
    }

    return true;
  }
}
